<template>
    <button v-if="!isUserThalesAdmin()"
    id='btn-nav'
    class="drop-down-menu"
    v-on:click="showNavbar"
    ></button>
</template>
<script>
export default {
    name: 'ToggleNavbar',

 methods: {
    showNavbar(event) {
    document.getElementById("app").firstElementChild.classList.toggle('show-navbar');
    document.getElementById("app").firstElementChild.classList.toggle('hide-navbar');
    document.getElementById("btn-nav").classList.toggle('btn-after');
    },
 },   
 mounted() {
    if (!this.isUserThalesAdmin() ) {
      document.body.style.padding = "0";
      let app = document.getElementById("app")
      app.style.margin = "0px 0 0 0";
      app.firstElementChild.classList.add("hide-navbar")
      app.firstElementChild.style.transition= "all 0.5s";
    }
  },
}
</script>
<style>
    .hide-navbar {
    top: -100px !important;
  }
  
   .show-navbar {
    transition: all 0.5s;
    top: 0px!important;
  } 

  .thales-container button#btn-nav {
    outline: none
  }

  .drop-down-menu {
    position: absolute;
    background-color:#4247462e;
    top: 76px;
    left: 50%;
    margin-bottom: -10px;
    transition: all 0.3s;
     border: none;
    border-radius: 50%;
    transition: all 0.5s;
    width: 50px;
    height: 50px;
    margin: 0 0 -25px 0;
    outline: none !important;
  }

  .drop-down-menu:hover {
    background-color: #424746cc;
  }

  .drop-down-menu::before {
    content: '\f078';
    font-family: "FontAwesome";
    font-size: 20px;
    color: white;
   
  }

  .btn-after {
    margin: 0 0 45px;
    transition: all 0.5s;
    z-index: 1050;
    top: 50px;
  }

  .btn-after::before {
    font-family: "FontAwesome";
    content:"\f077";
    font-size: 20px;
    size: 9;
  }
</style>


// WEBPACK FOOTER //
// src/components/ToggleNavBar.vue